import { gql } from 'apollo-angular';

export var update_project_detail_dates = gql`
  mutation UPDATE_PROJECT_DETAIL_DATES($input: ProjectDetailDatesInput!) {
    updateProjectDetailDates(input: $input) {
      id
      loi_expiration_date
      effective_closing_date
    }
  }
`;

export var update_project_dates = gql`
  mutation UPDATE_PROJECT_DATES($input: UpdateProjectDates) {
    updateProjectDates(input: $input) {
      projectDates {
        id
        project {
          id
          name
          projectDates {
            id
            date
            dateClass {
              id
              name
            }
            dateType {
              id
              name
              model
              active
            }
          }
        }
      }
    }
  }
`;

export var delete_project_date = gql`
  mutation DELETE_PROJECT_DATE($id: ID!) {
    deleteProjectDate(id: $id) {
      project {
        projectDates {
          id
          date
          dateClass {
            id
            name
          }
          dateType {
            id
            name
            model
            active
          }
        }
      }
    }
  }
`;

export const REFETCH_PROJECT_DETAILS_AND_DATES = gql`
  query refetchProjectDetailsAndDates($project_id: ID!) {
    project(id: $project_id) {
      projectDates {
        id
        date
        dateClass {
          id
          name
        }
        dateType {
          id
          name
          model
          active
        }
      }
      projectDetail {
        id
        loi_expiration_date
        effective_closing_date
      }
    }
  }
`;

export var update_detail_and_project_dates = gql`
  mutation UPDATE_DETAIL_AND_PROJECT_DATES(
    $detailInput: ProjectDetailDatesInput!
    $input: UpdateProjectDates
  ) {
    updateProjectDetailDates(input: $detailInput) {
      id
      loi_expiration_date
      effective_closing_date
    }
    updateProjectDates(input: $input) {
      projectDates {
        id
        project {
          id
          name
          projectDates {
            id
            date
            dateClass {
              id
              name
            }
            dateType {
              id
              name
              model
              active
            }
          }
        }
      }
    }
  }
`;
